export enum FormActive {
    Login,
    RegData,
    Email,
    Code,
    Password
}